import styled from "styled-components";

export const Container = styled.button`
  width: 100%;
  height: 48px;

  border-radius: 4px;

  background-color: ${({ bg }) => (bg ? "white" : "var(--black-action)")};
  color: ${({ bg }) => (bg ? "black" : "var(--white)")};
  border: 2px solid ${({ bg }) => (bg ? "black" : "none")};

  text-transform: uppercase;
  font-size: 1rem;
  font-weight: bold;

  cursor: pointer;

  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.9);
  }
`;
